import Vue from 'vue';
import VueI18n from 'vue-i18n';
import nl from '@/i18n/nl';

Vue.use(VueI18n);
const locales = { nl };

const i18n = new VueI18n({ locale: 'nl', messages: locales });

export default i18n;

export const $t = i18n.t.bind(i18n);
